
import axios, { AxiosInstance, AxiosError, AxiosRequestConfig, AxiosResponse } from 'axios'
import { ResultData } from '../interface/index'
import { LocalKeysEnum, localGet, localRemove } from '../core/local'
import { ResultEnum } from '../enums/index'
import { getApiUrl } from './config'
const axiosConfig = {
    // 默认地址请求地址，可在 .env 开头文件中修改
    baseURL: getApiUrl(),
    // 设置超时时间（10s）
    timeout: 10000,
    // 跨域时候允许携带凭证
    crossdomain: true,
    withCredentials: true,
    headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json;charset=UTF-8'
    },
    isTransformResponse: true,
    isJsonConent: false,

}
class RequestHttp {
    service: AxiosInstance
    public constructor(config: AxiosRequestConfig) {
        // 实例化axios
        this.service = axios.create(config)
        /**
		 * @description 请求拦截器
		 * 客户端发送请求 -> [请求拦截器] -> 服务器
		 * token校验(JWT) : 接受服务器返回的token,存储到redux/本地储存当中
		 */
        this.service.interceptors.request.use(
            (config: AxiosRequestConfig) => {
                const owner: string = localGet(LocalKeysEnum.OWNER)
                return { ...config, headers: { ...config.headers, 'owner': owner } }
            },
            (error: AxiosError) => {
                return Promise.reject(error)
            }
        )

        /**
		 * @description 响应拦截器
		 *  服务器换返回信息 -> [拦截统一处理] -> 客户端JS获取到信息
		 */
        this.service.interceptors.response.use(
            (response: AxiosResponse) => {
                const { data } = response
                if (data.code === ResultEnum.OVERDUE || data.code === ResultEnum.NOLOGIN) {
                    localRemove(LocalKeysEnum.TOKEN)
                    window.location.href = '/login'
                    return Promise.reject(data)
                }
                return data
            },
            async (error: AxiosError) => {
                return Promise.reject(error)
            }
        )
    }

    // * 常用请求方法封装
    get<T>(url: string, params?: object, _object = {}): Promise<ResultData<T>> {
        return this.service.get(url, { params, ..._object })
    }
    download(url: string, params?: object, _object = {}): Promise<Blob> {
        return this.service.get(url, { params, ..._object })
    }
    post<T>(url: string, params?: object, _object = {}): Promise<ResultData<T>> {
        return this.service.post(url, params, _object)
    }
    put<T>(url: string, params?: object, _object = {}): Promise<ResultData<T>> {
        return this.service.put(url, params, _object)
    }
    delete<T>(url: string, params?: object, _object = {}): Promise<ResultData<T>> {
        return this.service.delete(url, { params, ..._object })
    }
}

export default new RequestHttp(axiosConfig)